import { render, staticRenderFns } from "./NewCopiedDocumentEditView.vue?vue&type=template&id=d5cea646&scoped=true&"
import script from "./NewCopiedDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./NewCopiedDocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./NewCopiedDocumentEditView.vue?vue&type=style&index=0&id=d5cea646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cea646",
  null
  
)

export default component.exports